function activeSectionSliderInit() {
  const kgSliders = document.querySelectorAll(".kg-active-section__slider");

  kgSliders.forEach(function (slider) {
    if (!slider.classList.contains("swiper-initialized")) {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
          el: slider.querySelector(".swiper-pagination"),
          clickable: true
        },
        breakpoints: {
          525: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        },
      });
    }
  });
}

activeSectionSliderInit();
document.addEventListener("shopify:section:load", activeSectionSliderInit);
